import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/lnlApi";
import TemplatesTab from "./autoresp/TemplatesTab";
import RulesTab from "./autoresp/RulesTab";
import SignaturesTab from "./autoresp/SignaturesTab";
import SettingsTab from "./autoresp/SettingsTab";
import DeliveryTab from "./autoresp/DeliveryTab";
import StatusEmailsTab from "./autoresp/StatusEmailsTab";
import { errMsg } from "./autoresp/shared";

const TABS = [
    ["templates", "Templates", TemplatesTab],
    ["rules", "Automation Rules", RulesTab],
    ["status", "Status Update Emails", StatusEmailsTab],
    ["signatures", "Signatures", SignaturesTab],
    ["settings", "Automated Response Settings", SettingsTab],
    ["delivery", "Delivery & Audit", DeliveryTab],
];

export default function AutoResponsesPanel() {
    const [meta, setMeta] = useState(null);
    const [tab, setTab] = useState("templates");
    useEffect(() => { adminApi.get("/auto-responses/meta").then((r) => setMeta(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
    if (!meta) return <div className="text-sm text-lnl-gray">Loading…</div>;
    if (!meta.can.view) return <div className="lnl-card p-8 text-center text-lnl-gray">You don’t have permission to manage automated responses.</div>;
    const Active = TABS.find(([k]) => k === tab)[2];
    return (
        <div data-testid="auto-responses-panel">
            <div className="flex gap-1 overflow-x-auto border-b border-lnl-border mb-5 -mx-1 px-1">
                {TABS.map(([k, label]) => (
                    <button key={k} onClick={() => setTab(k)} data-testid={`autoresp-tab-${k}`}
                        className={`whitespace-nowrap px-4 py-2.5 text-sm font-heading font-semibold border-b-2 -mb-px transition-colors ${tab === k ? "border-lnl-green text-lnl-green-deep" : "border-transparent text-lnl-gray hover:text-lnl-charcoal"}`}>{label}</button>
                ))}
            </div>
            <Active meta={meta} />
        </div>
    );
}
